export default "__VITE_ASSET__DwrmZKGz__"